module.exports = __webpack_public_path__ + "img/P15.8e4be026.png";